import styled from "styled-components";
import { device } from "../../globalAssets/breakpoints";
import { desktop } from "../../globalAssets/fontsize";

export const Dropdown = styled.select`
  &&& {
    outline: none;
    border: none;
    background: ${(props) => props.theme.foreground};
    width: 100%;
    /* background-color: re; */
    padding: 5px 10px;
    font-size: 14px !important;
    color: ${(props) => props.theme.color};
    height: 100%;
    /* height: 2.5vw; */
    cursor: pointer;
    &:focus,
    &:active {
      font-size: 14px;
      outline: none;
      border: none;
    }
    @media ${device.laptop} {
      font-size: ${desktop.small} !important;
      &:focus,
      &:active {
        font-size: ${desktop.small};
      }
    }
  }
`;

export const Option = styled.option`
  font-size: 12px !important;
  background-color: ${(props) => props.theme.foreground} !important;
  @media ${device.laptop} {
    font-size: ${desktop.small} !important;
  }
`;
export const DetailsCard = styled.div`
  padding: 5px 10px;
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  margin-bottom: 10px;
  & > h2 {
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.color};
    border-bottom: ${(props) => `1px solid ${props.theme.primaryColor}`};
  }
  & > h3 {
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.color};

    & > a {
      text-decoration-color: ${(props) => props.theme.primaryColor};
    }
  }
  @media ${device.laptop} {
    padding: 0.5vw 1vw;
    background: ${(props) => props.theme.foreground};
    box-shadow: ${(props) => props.theme.subtleShadow};
    & > h2 {
      font-size: ${desktop.medium};
    }
    & > h3 {
      font-size: ${desktop.normal};
    }
  }
`;
export const ServiceCard = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  border-radius: 10px;
  padding: 10px 12px;
  img {
    height: 120px;
    width: 120px;
    border-radius: 5px;
    margin-right: 10px;
  }
  & > div {
    display: flex;
    align-items: center;
    h5 {
      color: ${(props) => props.theme.color};
      margin: 0;
      font-size: 15px;
    }
    h4 {
      color: ${(props) => props.theme.color};
      font-size: 14px;
      margin: 0 0 0 5px;
    }
  }
  @media ${device.laptop} {
    width: 95%;
    height: 100%;
    background-color: ${(props) => props.theme.foreground};
    box-shadow: ${(props) => props.theme.subtleShadow};
    border-radius: 10px;
    padding: 10px 12px;
    cursor: pointer;
    img {
      height: 5.5vw;
      width: 5.5vw;
    }
    & > div {
      display: flex;
      align-items: center;

      h5 {
        font-size: ${desktop.normal};
        margin: 0;
        /* text-transform: capitalize; */
      }
      h4 {
        color: ${(props) => props.theme.color};
        font-size: ${desktop.small};
        margin: 0 0 0 5px;
        /* text-transform: capitalize; */
      }
    }
    :hover {
      transform: scale(1.01);
    }
  }
`;

export const Rating = styled.div`
  font-weight: 400;
  color: ${(props) => props.theme.color};
  font-size: 14px;
  margin: 5px 0;
  div {
    background-color: grey;
  }
`;
export const SubmitButton = styled.button`
  padding: 5px;
  outline: none;
  cursor: pointer;
  border: none;
  background: ${(props) => props.theme.primaryColor};
  color: white;
  font-weight: 500;
  margin-top: 5px;
`;

export const RequestResponse = styled.div`
  font-weight: 400;
  color: ${(props) => props.theme.color};
  font-size: 14px;
  text-align: center;
  margin: 5px 0;
  span {
    color: red;
  }
`;

export const IDAvatar = styled.div`
  width: 37px;
  height: 37px;
  border-radius: 50%;
  display: grid;
  margin-right: 10px;
  place-items: center;
  color: white;
  background-color: ${(props) => props.theme.tint};
`;

export const CommentContainer = styled.div`
  display: flex;
  small {
    color: ${(props) => props.theme.grey};
  }
  p {
    margin: 0;
    color: ${(props) => props.theme.color};
    font-size: 12px;
  }
`;

export const UserImage = styled.img`
  height: 37px;
  width: 37px;
  margin-right: 10px;
  border-radius: 50%;
`;
